module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('auto-complete', {
    attrs: {
      "placeholder": "Address",
      "list": _vm.addresses,
      "selection": _vm.address.formatted_address,
      "loose": ""
    },
    on: {
      "input": _vm.findAddresses,
      "change": _vm.setAddress
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3a9f12e0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/GoogleAddressSearcher.vue
// module id = 380
// module chunks = 0